module.exports = ".page_loading {\r\n  height: 300px\r\n}\r\n"